import { render, staticRenderFns } from "./Sdgs.vue?vue&type=template&id=0560247b&scoped=true"
import script from "./Sdgs.vue?vue&type=script&lang=js"
export * from "./Sdgs.vue?vue&type=script&lang=js"
import style0 from "./Sdgs.vue?vue&type=style&index=0&id=0560247b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560247b",
  null
  
)

export default component.exports